import { apiGet, apiPost } from "./client.js";
import type {
  Website,
  IntakeResult,
  VerificationInfo,
  VerificationMethod,
} from "./types.js";

export interface CreateWebsiteResponse {
  ok: boolean;
  website: Website;
}

export interface ListWebsitesResponse {
  websites: Website[];
}

export interface VerifyResponse {
  ok: boolean;
  verified: boolean;
}

export function createWebsite(
  orgId: string,
  url: string,
): Promise<CreateWebsiteResponse> {
  return apiPost<CreateWebsiteResponse>(`/orgs/${orgId}/websites`, { url });
}

export function listWebsites(orgId: string): Promise<ListWebsitesResponse> {
  return apiGet<ListWebsitesResponse>(`/orgs/${orgId}/websites`);
}

export function runIntake(websiteId: string): Promise<IntakeResult> {
  return apiPost<IntakeResult>(`/websites/${websiteId}/intake`, {});
}

export function getVerificationInfo(
  websiteId: string,
): Promise<VerificationInfo> {
  return apiGet<VerificationInfo>(`/websites/${websiteId}/verification`);
}

export function verifyWebsite(
  websiteId: string,
  method: VerificationMethod,
): Promise<VerifyResponse> {
  return apiPost<VerifyResponse>(`/websites/${websiteId}/verify`, { method });
}
